import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import { DomUtils } from "@tento-ui/dom";

@component({ name: "std-blog-bear-header" })
export class BlogBearHeader extends LonaWebComponent {
  bind(props: BlogBearHeader.Props): this {
    props.title.slot = "nav-title";
    const children: HTMLElement[] = [props.title];

    for (const $link of props.links) {
      $link.slot = "nav-link";
      children.push($link);
    }

    DomUtils.reconcileChildren(this, children);

    return this;
  }

  static $html: Option<HTMLTemplateElement> = html`
    <header id="root">
      <slot name="nav-title"></slot>
      <nav id="nav">
        <slot name="nav-link"></slot>
      </nav>
    </header>
  `;

  static $styles = [
    css`
      :host {
        display: block;
        width: 100%;
      }

      #root {
        max-width: var(--max-width, 720px);
        margin: 0 auto;
        padding: 28px var(--brand-inline-padding, 40px) 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      #nav {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
      }

      ::slotted([slot="nav-title"]) {
        display: block;
      }

      ::slotted([slot="nav-link"]) {
        display: inline-block;
      }
    `,
  ];
}

export namespace BlogBearHeader {
  export type Props = {
    title: HTMLElement;
    links: HTMLElement[];
  };
}
